import { render, staticRenderFns } from "./edittask.vue?vue&type=template&id=7a8833a3&"
import script from "./edittask.vue?vue&type=script&lang=ts&"
export * from "./edittask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edittask.vue"
export default component.exports